'use client'

import { useState } from 'react'
import { motion } from 'framer-motion'
import { BackgroundBeams } from '../../_components/_ui/background-beams'

export default function FAQPage() {
    const [openIndex, setOpenIndex] = useState(null)

    const faqItems = [
        {
            question: 'Is there a FAQ page?',
            answer: 'You\'re looking at it! Congratulations on finding the very thing you were asking about. It\'s like asking if there\'s water while swimming in the ocean.',
        },
        {
            question: 'Is that the only thing here?',
            answer: 'Well, there\'s also this snarky response. And this one. And the crushing existential weight of an incomplete FAQ page. Feel free to ask more questions that we may or may not answer with equal amounts of sass.',
        },
        {
            question: 'What is Autofoc.us?',
            answer: 'It\'s like social media, but without the "social" part that makes you hate humanity. We help you focus on what matters - yourself! Autofoc.us is a platform where creators can build their own personal space online without the noise, algorithms, and constant comparison or companion of traditional social media. Think of it as your digital business card, portfolio, and content hub all in one sleek package. We offer different tiers (Basic, Turbo, and Summit) to match your needs, whether you\'re just starting out or a professional creator. And yes, we embrace a healthy dose of narcissism - after all, it\'s all about you here, and we listen and don\'t judge.',
        },
        {
            question: 'How much does it cost?',
            answer: 'It\'s free! Well, the basic version is. The premium versions cost actual money, which we then use to buy things like hosting. Our Turbo plan is $6.99/month and includes 5 additional pages, 10 blocks per page, basic analytics, and 50% ad block profit return. For professionals, our Summit plan at $16.99/month offers unlimited pages and blocks, custom domains, advanced analytics, premium block access, and 100% ad block profit return. Think of it as an investment in your digital presence. Capitalism, am I right?',
        },
    ]

    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index)
    }

    return (
        <div className="min-h-screen w-full relative">
            <BackgroundBeams />
            <div className="container mx-auto px-4 py-16 relative z-10">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="max-w-3xl mx-auto"
                >
                    <h1 className="text-4xl font-bold text-white mb-8 text-center">
                        Frequently Asked Questions
                    </h1>

                    <div className="space-y-4">
                        {faqItems.map((item, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{
                                    duration: 0.5,
                                    delay: index * 0.1,
                                }}
                                className="bg-neutral-900/50 backdrop-blur-sm rounded-lg overflow-hidden border border-neutral-800"
                            >
                                <button
                                    onClick={() => toggleAccordion(index)}
                                    className="flex justify-between items-center w-full p-4 text-left text-white font-medium"
                                >
                                    <span>{item.question}</span>
                                    <svg
                                        className={`w-5 h-5 transition-transform ${
                                            openIndex === index
                                                ? 'transform rotate-180'
                                                : ''
                                        }`}
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M19 9l-7 7-7-7"
                                        />
                                    </svg>
                                </button>
                                <div
                                    className={`transition-all duration-300 overflow-hidden ${
                                        openIndex === index
                                            ? 'max-h-full p-4 pt-0'
                                            : 'max-h-0'
                                    }`}
                                >
                                    <p className="text-gray-300">
                                        {item.answer}
                                    </p>
                                </div>
                            </motion.div>
                        ))}
                    </div>

                    <div className="mt-12 text-center">
                        <p className="text-gray-400">
                            Don't see your question here? Feel free to{' '}
                            <a
                                href="/support/contact"
                                className="text-indigo-400 hover:text-indigo-300"
                            >
                                contact us
                            </a>
                            .
                        </p>
                    </div>
                </motion.div>
            </div>
        </div>
    )
}
